module.exports = __webpack_public_path__ + "img/13.94dafb7c.svg";